import type { WebsitePreviewReducerState } from 'reducers/website/websitePreview';
import * as ActionTypes from '../types/website/WebsitePreviewActionTypes';
import type { WebsitePreviewActionTypes } from '../types/website/WebsitePreviewActionTypes';

export function updatePreview(
  preview: Partial<WebsitePreviewReducerState>
): WebsitePreviewActionTypes {
  return {
    type: ActionTypes.UPDATE_PREVIEW,
    payload: preview,
  };
}
